























import { Vue, Prop, Component } from 'vue-property-decorator';
import { TextValuePair } from '@/models/TextValuePair';

@Component
export default class RadioGroup extends Vue {
    @Prop({ default: () => [] }) options!: TextValuePair[];
    @Prop() label!: string;
    @Prop({ default: false }) formError!: boolean;
    @Prop({ default: 0 }) tabIndex!: number;

    selectedValue: string | null = null;

    onChange() {
        this.$emit('input', this.selectedValue);
        this.$emit('clearError');
    }

    onBlur(e: FocusEvent) {
        // Only emit blur if the user tabs completely out of the radio group
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.$emit('blur');
        }
    }
}
